// extracted by mini-css-extract-plugin
module.exports = {"item":"OfflineOrderDetailsItems_item__1hdvH"};